<template>
  <authorization permissionKey="configuration_facilitator_allergy" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de alergias
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <AllergyList
                v-if="key === 'type'"
                :facilitators="allergyTypes"
                :facilitatorType="key"
                :refreshList="refreshList"
              />

              <AllergyList
                v-else-if="key === 'substance'"
                :facilitators="allergySubstances"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import AllergyList from "@/components/config/allergy/list/index.vue";

  export default {
    name: "HFConfig",
    components: {
      AllergyList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          type: "Tipo",
          substance: "Substância",
        },
      };
    },
    apollo: {
      allergySubstances: {
        query: require("@/graphql/allergy_substances.gql"),
        pollInterval: 20000,
      },
      allergyTypes: {
        query: require("@/graphql/allergy_types.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.allergySubstances.refetch();
        this.$apollo.queries.allergyTypes.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
